import { useMemo } from "react";
import { FC } from "react";
import { UseFormRegisterReturn } from "react-hook-form";

interface Props {
  value: string;
  register: UseFormRegisterReturn;
  label: string;
  defaultChecked?: boolean;
}

const RadioTile: FC<Props> = ({
  value,
  register,
  label,
  defaultChecked = false,
}): JSX.Element => {
  const id = useMemo(() => (value ? String(value) : "unspecified"), [value]);

  return (
    <div>
      <label
        htmlFor={id}
        className="flex items-center space-x-8 px-12 py-12 text-sm"
      >
        <input
          {...register}
          id={id}
          type="radio"
          value={value}
          defaultChecked={defaultChecked}
        />
        <span className="flex-1">{label}</span>
      </label>
    </div>
  );
};
export default RadioTile;
